import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles({
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // background: "green",
    // height: "100%",
    // width: "100%",
  },

  box: {
    padding: "2%",
    margin: "2%",
    background: "#fff",
    width: "100%",
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  heading: {
    fontWeight: "500",
    fontSize: 23,
    fontFamily: "Poppins",
    letterSpacing: 1,
    padding: 5,
    paddingBottom: 2,
    flexDirection: "row",
    alignSelf: "center",
  },
  rowStyle: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "center",
    margin: "1%",
  },
  image: {
    fontWeight: 450,
    fontSize: 20,
    padding: 10,
  },
  dialogtitle: {
    display: "flex",
    justifyContent: "space-between",
  },
  CloseIcon: {
    cursor: "pointer",
  },
});
